
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire75f2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire75f2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $h6ark = parcelRequire("h6ark");
document.getElementById("pair").addEventListener("click", async ()=>{
    await (0, $h6ark.pair_device)();
});
document.getElementById("start").addEventListener("click", async ()=>{
    await (0, $h6ark.connect_device)();
});
document.getElementById("disconnect").addEventListener("click", async ()=>{
    await (0, $h6ark.disconnect)();
});
document.querySelector("#test_cmd").addEventListener("click", async ()=>{
    const command_output = await (0, $h6ark.godo)("ls /", true);
    console.log(command_output);
    console.log(command_output.stderr);
    console.log(command_output.stdout);
});
document.querySelector("#exploit").addEventListener("click", async ()=>{
    await (0, $h6ark.exploit_gabb)();
});
document.querySelector("#install").addEventListener("click", async ()=>{
    const file_input = document.querySelector("#apk");
    const file = file_input.files[0];
    const user_select = document.querySelector("#users");
    (0, $h6ark.install_app)(file, user_select.value);
});
document.querySelector("#send").addEventListener("click", async ()=>{
    const file = document.querySelector("#sender").files[0];
    (0, $h6ark.send_to_device)(file);
});
document.querySelector("#run").addEventListener("click", async ()=>{
    const runner = document.querySelector("#runner");
    await (0, $h6ark.godo)(runner.value);
    runner.value = "";
    runner.focus();
});
const $e0cf9ec953235470$var$device_list = document.querySelector("#devices");
$e0cf9ec953235470$var$device_list.addEventListener("change", ()=>{
    (0, $h6ark.select_existing)($e0cf9ec953235470$var$device_list.value);
});
const $e0cf9ec953235470$var$autoconnect = document.querySelector('[name="autoconnect"]');
$e0cf9ec953235470$var$autoconnect.checked = (0, $h6ark.get_autoconnect)();
$e0cf9ec953235470$var$autoconnect.addEventListener("change", ()=>{
    (0, $h6ark.set_autoconnect)($e0cf9ec953235470$var$autoconnect.checked);
});
document.querySelector("#startshizuku").addEventListener("click", ()=>{
    (0, $h6ark.godo)(`sh /sdcard/Android/data/moe.shizuku.privileged.api/start.sh`);
});
(0, $h6ark.monitor_usb)($e0cf9ec953235470$var$device_list);


//# sourceMappingURL=dev_panel.b0b95aaa.js.map
